<nav class="sz-tab-bar" role="tablist">
  @for (item of items(); let i = $index; track item.route) {
    @if (i === 2) {
      <div class="sz-tab-bar__fab-slot">
        <button
          type="button"
          class="sz-tab-bar__fab"
          [class.is-active]="fabActive()"
          [disabled]="fabDisabled()"
          [attr.aria-label]="fabAriaLabel()"
          [attr.aria-pressed]="fabActive()"
          (click)="emitFab()">
          <sz-icon [name]="fabActive() ? 'x' : 'play'" [size]="22" />
        </button>
      </div>
    }
    <a class="sz-tab-bar__tab" [routerLink]="item.route" routerLinkActive="is-active" role="tab">
      <sz-icon class="sz-tab-bar__icon" [name]="item.icon" [size]="20" />
      <span class="sz-tab-bar__label">{{ item.label }}</span>
      <span class="sz-tab-bar__tick" aria-hidden="true"></span>
    </a>
  }
</nav>
